var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fill-height d-flex flex-column justify-lg-space-between" },
    [
      _c("div", { staticClass: "editor d-flex fill-height" }, [
        _c("div", {
          staticClass: "markdown-editor",
          attrs: { id: _vm.editorId },
          on: { drop: _vm.onDrop },
        }),
        _vm._v(" "),
        _vm.examGenerationLoading
          ? _c(
              "div",
              {
                staticClass:
                  "loading-box d-flex justify-content-center align-items-center",
              },
              [_vm._m(0)]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.school.use_ai_exam_generation
        ? _c("div", { staticClass: "pt-1 d-flex flex-column" }, [
            _c(
              "div",
              {
                staticClass:
                  "border border-success rounded bg-light p-2 h-100 d-flex flex-column",
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-row justify-space-between" },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.examGenerationLoading
                            ? "テストを生成しています。"
                            : "作りたいテストを教えてください。"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-decoration-none text-primary font-weight-bold",
                        on: {
                          click: function ($event) {
                            _vm.showAutoQuestionStatus =
                              !_vm.showAutoQuestionStatus
                          },
                        },
                      },
                      [
                        _vm.showAutoQuestionStatus
                          ? _c(
                              "div",
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { "aria-hidden": "false" } },
                                  [
                                    _vm._v(
                                      "\n              keyboard_arrow_down\n            "
                                    ),
                                  ]
                                ),
                                _vm._v("\n            閉じる\n          "),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { "aria-hidden": "false" } },
                                  [
                                    _vm._v(
                                      "\n              keyboard_arrow_up\n            "
                                    ),
                                  ]
                                ),
                                _vm._v("\n            開く\n          "),
                              ],
                              1
                            ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class:
                      "ai-generate-collapsable " +
                      (_vm.showAutoQuestionStatus ? "show" : ""),
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "row align-items-center" },
                        [
                          _c("v-col", { attrs: { cols: "4" } }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedQuestionPromptId,
                                    expression: "selectedQuestionPromptId",
                                  },
                                ],
                                staticClass: "form-select",
                                attrs: { disabled: _vm.examGenerationLoading },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedQuestionPromptId = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { key: 0, attrs: { value: "" } }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.promptForQuestions,
                                  function (option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.id,
                                        domProps: { value: option.id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(option.title) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "8" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.instructionQuestionForUser) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.examGenerationLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.stopMessage },
                                  },
                                  [
                                    _c("v-icon", [_vm._v("mdi-stop")]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ms-1" }, [
                                      _vm._v("生成を停止する"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "input-group flex-grow-1 mt-2",
                        staticStyle: { height: "134px" },
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.msg,
                              expression: "msg",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            "aria-label": "作りたいテストを教えてください",
                          },
                          domProps: { value: _vm.msg },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.msg = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              disabled: _vm.examGenerationLoading,
                              type: "button",
                            },
                            on: { click: _vm.sendMessage },
                          },
                          [_c("v-icon", [_vm._v("mdi-send")])],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-success",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spinner-grow text-success", attrs: { role: "status" } },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border spinner-border-sm text-success",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "spinner-grow spinner-grow-sm text-success",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }